import { Alert, Box } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

export const CloseWindowContent: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation("ucet");
  const messageKey = searchParams.get("messageKey") ?? "";

  useEffect(() => {
    const timer = setTimeout(() => {
      window.close();
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <Alert severity="info">{t(messageKey, messageKey)}</Alert>
    </Box>
  );
};
